
import { Search } from 'lucide-react';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const Hero = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [imageLoaded, setImageLoaded] = useState(false);
  const navigate = useNavigate();

  // Preload the hero image
  useEffect(() => {
    const img = new Image();
    img.src = "/lovable-uploads/1b20e123-a7c9-4c6e-9f8e-e4721695114d.png";
    img.onload = () => setImageLoaded(true);
  }, []);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search-mentors?q=${encodeURIComponent(searchQuery.trim())}`);
    } else {
      navigate('/search-mentors');
    }
  };

  return (
    <section className="relative min-h-screen pt-20 xs:pt-24 sm:pt-28 pb-12 sm:pb-16 px-4 sm:px-6 md:px-10 flex flex-col justify-center overflow-hidden bg-emu-blue">
      <div className="container mx-auto max-w-7xl z-10 flex-1 flex flex-col items-center justify-center">
        <div className="flex flex-col items-center justify-center text-center mb-8 xs:mb-10 sm:mb-12 md:mb-16">
          {/* Logo Image with loading optimization */}
          <img 
            src="/lovable-uploads/1b20e123-a7c9-4c6e-9f8e-e4721695114d.png" 
            alt="EMU Logo" 
            className={`w-[85vw] xs:w-[80vw] max-w-[800px] mb-6 xs:mb-8 ${imageLoaded ? 'animate-fade-in' : 'opacity-0'}`}
            loading="eager"
            width="800"
            height="450"
          />
          <h2 className="text-white text-lg xs:text-xl sm:text-2xl md:text-3xl font-medium mt-2 px-2">
            Where <span className="font-bold text-xl xs:text-2xl sm:text-3xl md:text-5xl block xs:inline">Everyone Mentors You</span>
          </h2>
        </div>
        
        <div className="w-full max-w-4xl mx-auto mt-6 xs:mt-8 animate-fade-in">
          <div className="bg-white rounded-lg p-4 xs:p-6 shadow-elevated">
            <form onSubmit={handleSearch} className="flex flex-col xs:flex-row gap-3 xs:gap-2">
              <div className="relative flex-1">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
                <Input
                  type="text"
                  placeholder="Search by company, skills or role..."
                  className="pl-10 w-full h-12 xs:h-12 text-sm xs:text-base"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
              <Button 
                type="submit" 
                className="bg-emu-blue hover:bg-emu-darkblue text-white h-12 px-6 xs:px-8 text-sm xs:text-base whitespace-nowrap"
              >
                <span className="hidden xs:inline">Search Mentors</span>
                <span className="xs:hidden">Search</span>
              </Button>
            </form>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-6 xs:bottom-8 left-1/2 transform -translate-x-1/2 z-10 flex flex-col items-center justify-center w-full max-w-xs">
        <a href="#top-mentors" className="flex flex-col items-center text-white/60 hover:text-white transition-colors animate-bounce">
          <span className="text-xs xs:text-sm font-medium mb-2 text-center">Discover More</span>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 xs:w-6 xs:h-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
          </svg>
        </a>
      </div>
    </section>
  );
};

export default Hero;
